(() => {
  const roots = [...document.querySelectorAll('[data-sd-quick-add]')];
  if (!roots.length) return;
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const setStatus = (root, message, state = '') => {
    const status = root.querySelector('[data-quick-status]');
    if (!status) return;
    status.textContent = message;
    if (state) status.dataset.state = state; else delete status.dataset.state;
  };
  // 5 oct (Carlos: "Agregar tarda mucho en cambiar al + y -"): si ya tenemos el carrito no se vuelve a pedir
  const updateCounter = async (ya) => {
    let cart = ya;
    if (!cart) {
      const response = await fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No pudimos actualizar el contador del carrito.');
      cart = await response.json();
    }
    document.querySelectorAll('.cart-counter').forEach((counter) => { counter.textContent = cart.item_count; });
    document.querySelectorAll('.depot-cart-link').forEach((link) => {
      link.setAttribute('aria-label', `Carrito, ${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'}`);
    });
  };
  // Carlos 29 sep: en las tarjetas nuevas (sdo-form) "Agregar" NO saca al cliente de la pagina.
  // Agrega ahi mismo y el boton se vuelve un contador (menos, cantidad, mas) que suma o resta del carrito.
  const cambiaCarrito = async (ruta, cuerpo) => {
    const r = await fetch(`${rootPath()}${ruta}`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo) });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || 'No pudimos actualizar tu carrito.');
    return j;
  };
  const cantidadEn = (cart, id) => cart.items.filter((i) => String(i.variant_id) === String(id)).reduce((s, i) => s + i.quantity, 0);
  const pintaPaso = (root, n) => {
    const boton = root.querySelector('[data-quick-submit]');
    let paso = root.querySelector('.sdo-paso');
    if (n <= 0) { paso?.remove(); if (boton) boton.hidden = false; return; }
    if (!paso) {
      paso = document.createElement('div'); paso.className = 'sdo-paso'; paso.setAttribute('role', 'group');
      paso.innerHTML = '<button type="button" data-d="-1" aria-label="Quitar uno">\u2212</button><span aria-live="polite"></span><button type="button" data-d="1" aria-label="Agregar uno">+</button>';
      boton?.insertAdjacentElement('afterend', paso);
      paso.addEventListener('click', async (e) => {
        const b = e.target.closest('[data-d]'); if (!b || paso.dataset.ocupado) return;
        const id = root.querySelector('[data-quick-variant-id]')?.value; const actual = Number(paso.querySelector('span').textContent) || 0;
        const nuevo = Math.max(0, actual + Number(b.dataset.d));
        paso.querySelector('span').textContent = nuevo || '\u2026';
        paso.dataset.ocupado = '1'; paso.querySelectorAll('button').forEach((x) => { x.disabled = true; });
        try {
          const cart = await cambiaCarrito('cart/change.js', { id: String(id), quantity: nuevo });
          pintaPaso(root, cantidadEn(cart, id)); updateCounter(cart).catch(() => {});
        } catch (err) { setStatus(root, err.message, 'error'); }
        finally { delete paso.dataset.ocupado; paso.querySelectorAll('button').forEach((x) => { x.disabled = false; }); }
      });
    }
    if (boton) boton.hidden = true;
    paso.querySelector('span').textContent = n;
  };
  const tarjetas = roots.filter((r) => r.classList.contains('sdo-form'));
  if (tarjetas.length) fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
    tarjetas.forEach((root) => { const id = root.querySelector('[data-quick-variant-id]')?.value; const n = cantidadEn(cart, id); if (n) pintaPaso(root, n); });
  }).catch(() => {});
  // 5 oct: también se llama con las tarjetas que agrega la carga automática de la página siguiente (sd:productos-cargados)
  const iniciar = (root) => {
    if (root.dataset.sdIni) return; root.dataset.sdIni = '1';
    const form = root;
    const quantity = root.querySelector('[data-quick-quantity]');
    const select = root.querySelector('[data-quick-variant-select]');
    const variantId = root.querySelector('[data-quick-variant-id]');
    const price = root.querySelector('[data-quick-price]');
    const submit = root.querySelector('[data-quick-submit]');
    const variants = JSON.parse(root.querySelector('[data-quick-variants]')?.textContent || '[]');
    let busy = false;
    const current = () => variants.find((variant) => String(variant.id) === String(select?.value || variantId?.value));
    const syncVariant = () => {
      const variant = current();
      if (!variant) return;
      if (price) price.textContent = variant.price;
      if (submit) { submit.disabled = !variant.available || busy; submit.textContent = variant.available ? 'Agregar' : 'No disponible'; }
    };
    root.querySelector('[data-quick-quantity-minus]')?.addEventListener('click', () => { if(busy)return; quantity.value = Math.max(1, (Math.floor(Number(quantity.value)) || 1) - 1); quantity.dispatchEvent(new Event('change')); });
    root.querySelector('[data-quick-quantity-plus]')?.addEventListener('click', () => { if(busy)return; quantity.value = Math.max(1, Number(quantity.value) || 1) + 1; quantity.dispatchEvent(new Event('change')); });
    quantity?.addEventListener('change', () => { quantity.value = Math.max(1, Math.floor(Number(quantity.value) || 1)); });
    select?.addEventListener('change', () => { if (variantId) variantId.value = select.value; setStatus(root, ''); syncVariant(); });
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const variant = current();
      const qty = Math.max(1, Math.floor(Number(quantity.value) || 1));
      if (!variant?.available) { setStatus(root, 'Esta presentación no está disponible.', 'error'); syncVariant(); return; }
      const tarjeta = form.classList.contains('sdo-form');
      const antes = Number(root.querySelector('.sdo-paso span')?.textContent) || 0;
      busy = true; quantity.value = qty; submit.disabled = true; if (quantity) quantity.disabled = true; if (select) select.disabled = true; root.querySelectorAll('[data-quick-quantity-minus],[data-quick-quantity-plus]').forEach(b=>b.disabled=true);
      // 5 oct: el botón cambia a "- 1 +" en cuanto se toca; antes esperaba 3 peticiones seguidas (agregar, contador y carrito)
      if (tarjeta) { setStatus(root, ''); pintaPaso(root, antes + qty); const p0 = root.querySelector('.sdo-paso'); if (p0) p0.dataset.ocupado = '1'; } else setStatus(root, 'Agregando a tu carrito…');
      try {
        const response = await fetch(`${rootPath()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: qty }] }) });
        let result = {}; try { result = await response.json(); } catch (_) {}
        if (!response.ok) throw new Error(result.description || 'No pudimos agregar este producto. Intenta de nuevo.');
        setStatus(root, ''); // 3 oct (E3/E4): el único aviso es el de abajo (sdCarrito.agregado)
        const real = Number((result.items || [result])[0]?.quantity);
        if (tarjeta && real > 0) pintaPaso(root, real);
        updateCounter().catch(() => {}); // sin esperar: el número del carrito llega solo
        if (window.sdCarrito) window.sdCarrito.agregado(); // Carlos 2 oct: en NINGUNA tarjeta se abre el carrito al agregar
      } catch (error) { if (tarjeta) pintaPaso(root, antes); setStatus(root, error.message || 'Revisa tu conexión e intenta de nuevo.', 'error'); }
      finally { busy = false; { const p1 = root.querySelector('.sdo-paso'); if (p1) delete p1.dataset.ocupado; } root.querySelectorAll('[data-quick-quantity-minus],[data-quick-quantity-plus]').forEach(b=>b.disabled=false); if (quantity) quantity.disabled = false; if (select) select.disabled = false; syncVariant(); }
    });
    syncVariant();
  };
  roots.forEach(iniciar);
  document.addEventListener('sd:productos-cargados', () => document.querySelectorAll('[data-sd-quick-add]').forEach(iniciar));
})();
